
<template>
    
        <mars-view v-if="show" class="popup" @touchmove.native.stop><mars-view class="mask" @click.native="clickMask"></mars-view><mars-view :style="{
            transform: type === 'center' ? 'translate(-50%, -50%)' : 'translateY(' + translateY + ')',
        }" class="main" :class="{'center': type === 'center', 'safe-area': addSafeArea}"><mars-view class="header"><mars-view v-if="title" class="title">{{ title }}</mars-view><mars-view v-if="type !== 'center'" class="close-icon" @click.native="closePopup"></mars-view></mars-view><mars-view class="content"><slot></slot></mars-view></mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    // 弹框类型，底部弹出：bottom，中部：center
    type: {
      type: String,
      default: 'bottom'
    },
    // 点击遮罩是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    addSafeArea: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      translateY: '100%'
    };
  },
  watch: {
    show(newVal) {
      this.translateY = newVal ? 0 : '100%'; // 控制动效
    }
  },

  methods: {
    /**
     * 点击遮罩
     */
    clickMask() {
      if (this.closeOnClickOverlay) {
        this.closePopup();
      }
    },
    closePopup() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.mask {
  position: fixed;
  z-index: 800;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.65);
  transition: opacity 0.16s cubic-bezier(0, 0, 0.3, 1);
}
.main {
  position: fixed;
  z-index: 810;
  max-height: 70%;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-top-left-radius: 0.21rem;
  border-top-right-radius: 0.21rem;
  transition: all 0.3s cubic-bezier(0.42, 0, 0.52, 1);
}
.main.safe-area {
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
.main.center {
  border-radius: 0.21rem;
  top: 50%;
  left: 50%;
  width: 3.31rem;
  height: 3.23rem;
  overflow: hidden;
}
.main .header {
  position: relative;
  text-align: center;
  height: 0.53rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.03rem;
  box-sizing: border-box;
}
.main .header .title {
  font-family: PingFangSC-Medium;
  font-size: 0.18rem;
  color: #1f1f1f;
  letter-spacing: 0;
  line-height: 0.2rem;
  font-weight: 500;
}
.main .header .close-icon {
  height: 0.18rem;
  width: 0.18rem;
  position: absolute;
  top: 50%;
  right: 0.17rem;
  transform: translateY(-50%);
  background: url('https://lvlin-base.cdn.bcebos.com/law/components/base-popup/close.png') no-repeat center center / 0.12rem 0.12rem;
}

</style>
